export { AcademyMobileMenu as DocsMobileMenu } from '../AcademyMobileMenu'
